// Authentication constants
const USER_LOGIN = "USER_LOGIN";
const USER_LOGOUT = "USER_LOGOUT";

// Video Filter constants
const CLEAR_CATEGORY_FILTER = "CLEAR_CATEGORY_FILTER";

// Liked Videos, Watch History, Watch Later, and PlayList Management constants
const SAVE_USER_LIKED_VIDEOS = "GET_USER_LIKED_VIDEOS";
const ADD_TO_LIKED_VIDEOS = "ADD_TO_LIKED_VIDEOS";
const REMOVE_FROM_LIKED_VIDEOS = "REMOVE_FROM_LIKED_VIDEOS";
const SAVE_USER_WATCH_HISTORY = "GET_USER_WATCH_HISTORY";
const ADD_TO_WATCH_HISTORY = "ADD_TO_WATCH_HISTORY";
const REMOVE_FROM_WATCH_HISTORY = "REMOVE_FROM_WATCH_HISTORY";
const CLEAR_WATCH_HISTORY = "CLEAR_WATCH_HISTORY";
const SAVE_USER_WATCH_LATER = "GET_USER_WATCH_LATER";
const ADD_TO_WATCH_LATER = "ADD_TO_WATCH_LATER";
const REMOVE_FROM_WATCH_LATER = "REMOVE_FROM_WATCH_LATER";
const SAVE_USER_PLAYLISTS = "GET_USER_PLAYLISTS";
const ADD_NEW_PLAYLIST = "ADD_NEW_PLAYLIST";
const REMOVE_PLAYLIST = "REMOVE_PLAYLIST";
const GET_VIDEOS_FROM_PLAYLIST = "GET_VIDEOS_FROM_PLAYLIST";
const ADD_VIDEO_TO_PLAYLIST = "ADD_VIDEO_TO_PLAYLIST";
const REMOVE_VIDEO_FROM_PLAYLIST = "REMOVE_VIDEO_FROM_PLAYLIST";

export { 
    USER_LOGIN, 
    USER_LOGOUT, 
    CLEAR_CATEGORY_FILTER,
    SAVE_USER_LIKED_VIDEOS,
    SAVE_USER_WATCH_HISTORY,
    ADD_TO_WATCH_HISTORY,
    REMOVE_FROM_WATCH_HISTORY,
    CLEAR_WATCH_HISTORY,
    SAVE_USER_WATCH_LATER,
    ADD_TO_WATCH_LATER,
    REMOVE_FROM_WATCH_LATER,
    SAVE_USER_PLAYLISTS,
    ADD_TO_LIKED_VIDEOS,
    REMOVE_FROM_LIKED_VIDEOS,
    ADD_NEW_PLAYLIST,
    REMOVE_PLAYLIST,
    GET_VIDEOS_FROM_PLAYLIST,
    ADD_VIDEO_TO_PLAYLIST,
    REMOVE_VIDEO_FROM_PLAYLIST
};
